import clsx from 'clsx';
import Link from 'next/link';
import styles from './styles.module.css';
type LinkComponentProps = {
  href: string;
  variants: 'primary' | 'primary-outline' | 'secondary';
  children: React.ReactNode;
  className: string;
};
export default function LinkComponent({ href, variants, className, children }: LinkComponentProps) {
  return (
    <Link
      href={href}
      className={clsx(className, {
        [styles.button_transition__primary as string]: variants === 'primary',
        [styles.button_transition__primary_outline as string]: variants === 'primary-outline',
        [styles.button_transition__white as string]: variants === 'secondary',
      })}
    >
      {children}
    </Link>
  );
}

/* hover:ring-primary-bg */
